import { Language } from "../../types";
import { Rating } from "../components";

interface AverageDishRatingProps {
  language: Language;
  averageRating?: number;
  numberOfRatings?: number;
  fallback?: string;
}

const intl = {
  no: {
    NEW_RECIPE: "Ny oppskrift",
    OUT_OF: "av",
  },
  se: {
    NEW_RECIPE: "Nytt recept",
    OUT_OF: "av",
  },
  dk: {
    NEW_RECIPE: "Ny opskrift",
    OUT_OF: "af",
  },
};

const AverageDishRating = ({
  language,
  averageRating,
  numberOfRatings,
}: AverageDishRatingProps) => {
  const { NEW_RECIPE, OUT_OF } = intl[language];

  if (!averageRating) {
    return (
      <div className="flex items-center h-6 text-xs text-grey-1">
        {NEW_RECIPE}
      </div>
    );
  }

  return (
    <div className="flex items-center h-6 gap-1">
      <Rating
        value={averageRating}
        numOptions={5}
        size={20}
        separator={OUT_OF}
        readOnly
      />
      <span className="text-xs leading-4 ml-1 mt-1.5 text-grey-1">
        {averageRating} ({numberOfRatings})
      </span>
    </div>
  );
};

export default AverageDishRating;
